import * as React from 'react'
import { lightTheme } from '@/customTheme'

type IconProps = {
  disabled?: boolean
  size?: number
}

function PoseSuggestIcon({ disabled, size = 24 }: IconProps) {
  const color = disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <g transform="translate(7 1)">
        <path
          d="M0 13.2385C0 13.7676 0.422603 14.189 0.959165 14.189C1.49098 14.189 1.91834 13.7676 1.91834 13.2385V9.51089C1.91834 9.36104 2.04654 9.23924 2.19849 9.23924C2.35518 9.23924 2.47864 9.36104 2.47864 9.51089V20.8528C2.47864 21.4287 2.94398 21.883 3.52803 21.883C4.10258 21.883 4.57742 21.424 4.57742 20.8528V13.9315C4.57742 13.7816 4.70562 13.6505 4.85757 13.6505C5.01426 13.6505 5.14247 13.7816 5.14247 13.9315V20.8528C5.14247 21.424 5.61255 21.883 6.19185 21.883C6.7759 21.883 7.24124 21.4287 7.24124 20.8528V9.51089C7.24124 9.36104 7.35995 9.23924 7.51665 9.23924C7.66859 9.23924 7.7968 9.36104 7.7968 9.51089V13.2385C7.7968 13.7676 8.22412 14.189 8.75598 14.189C9.29253 14.189 9.71515 13.7676 9.71515 13.2385V9.0754C9.71515 6.8838 8.01997 5.43212 5.61255 5.43212H4.10258C1.69517 5.43212 0 6.8838 0 9.0754V13.2385ZM4.85757 4.40657C6.09214 4.40657 7.09405 3.42317 7.09405 2.20564C7.09405 0.988095 6.09214 0 4.85757 0C3.62299 0 2.6211 0.988095 2.6211 2.20564C2.6211 3.42317 3.62299 4.40657 4.85757 4.40657Z"
          fill={color}
        />
      </g>
    </svg>
  )
}

export default PoseSuggestIcon
